<template>
  <v-text-field v-model="thisValue" :rules="fieldRules" label="Merchant ID" required  hint="Required" persistent-hint></v-text-field>
</template>

<script>
export default {
  name: 'OrderDetailMerchantId',
  data () {
    return {
      fieldRules: [v => !!v || 'This information is required']
    }
  },
  computed: {
    thisValue: {
      get () {
        return this.$store.state.order.merchantId
      },
      set (val) {
        this.$store.commit('updateOrder', ['merchantId', val])
      }
    }
  }
}
</script>

<style scoped>

</style>
